import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { AuthService } from '../services/auth.service';

export const helpAvailabilityGuard: CanActivateFn = async (route) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const user = await firstValueFrom(authService.getUserInfoOrRefreshIfNeeded());

  if (!user.gar_ido) {
    return true;
  }

  const fallbackPath = route.routeConfig?.path === 'helptp' ? 'hometp' : 'homec';
  router.navigate([fallbackPath]);
  return false;
};
